import type { SearchContestEntrantEntry } from './search-contest-entrants.model';

export interface GenerateSearchContestEntrantsOptions {
  readonly entrants: readonly SearchContestEntrantEntry[];
}

export function generateSearchContestEntrantsObjects({
  entrants,
}: GenerateSearchContestEntrantsOptions): readonly SearchContestEntrantEntry[] {
  return entrants.map(entrant => ({
    id: entrant.id,
    username: entrant.username,
    publicName: entrant.publicName,
  }));
}
